import { useState } from 'react';

const RISK_COLORS = {
  low:    { bg: '#0f2a1a', border: '#1a4a2a', text: '#4ade80', label: 'Low Risk' },
  medium: { bg: '#2a1f0a', border: '#4a380a', text: '#fbbf24', label: 'Medium Risk' },
  high:   { bg: '#2a0f0f', border: '#4a1a1a', text: '#f87171', label: 'High Risk' },
};

const RISK_ICONS = {
  low:    '✓',
  medium: '⚠',
  high:   '!',
};

export default function AIDetectionBadge({ detection, targetLang }) {
  const [expanded, setExpanded] = useState(false);

  if (!detection) return null;

  const { score, risk_level, message, powered_by } = detection;
  const colors = RISK_COLORS[risk_level] || RISK_COLORS.medium;

  return (
    <div style={{
      marginTop: '12px',
      border: `1px solid ${colors.border}`,
      borderRadius: '8px',
      background: colors.bg,
      overflow: 'hidden',
      transition: 'all 0.2s ease',
    }}>
      {/* Header row */}
      <div
        onClick={() => setExpanded(!expanded)}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '10px 14px',
          cursor: 'pointer',
          userSelect: 'none',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span style={{
            width: '22px',
            height: '22px',
            borderRadius: '50%',
            background: colors.border,
            color: colors.text,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '12px',
            fontWeight: '700',
            flexShrink: 0,
          }}>
            {RISK_ICONS[risk_level]}
          </span>
          <span style={{
            fontSize: '13px',
            fontWeight: '600',
            color: colors.text,
          }}>
            AI Detection: {colors.label}
          </span>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          {/* Score pill */}
          <span style={{
            fontSize: '12px',
            fontWeight: '700',
            color: colors.text,
            background: colors.border,
            padding: '2px 8px',
            borderRadius: '12px',
          }}>
            {score}%
          </span>
          {/* Expand arrow */}
          <span style={{
            color: colors.text,
            fontSize: '11px',
            transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 0.2s',
          }}>▼</span>
        </div>
      </div>

      {/* Score bar */}
      <div style={{ padding: '0 14px 10px' }}>
        <div style={{
          height: '4px',
          background: 'rgba(255,255,255,0.08)',
          borderRadius: '2px',
          overflow: 'hidden',
        }}>
          <div style={{
            height: '100%',
            width: `${score}%`,
            background: colors.text,
            borderRadius: '2px',
            transition: 'width 0.6s ease',
          }} />
        </div>
      </div>

      {/* Expanded details */}
      {expanded && (
        <div style={{
          borderTop: `1px solid ${colors.border}`,
          padding: '12px 14px 14px',
        }}>
          <p style={{
            fontSize: '12px',
            color: 'rgba(255,255,255,0.7)',
            margin: '0 0 8px',
            lineHeight: '1.5',
          }}>
            {message}
          </p>
          <p style={{
            fontSize: '11px',
            color: 'rgba(255,255,255,0.35)',
            margin: 0,
          }}>
            Powered by {powered_by} · Score reflects AI writing patterns,
            not content authorship. Translations of human-written content
            may score higher due to consistent phrasing.
          </p>
        </div>
      )}
    </div>
  );
}
